import { useEffect, useState } from 'react';
import { Img } from 'react-image';
import { useThemeContext } from 'src/context/ThemeProvider';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import styled from '@emotion/styled';
// import placedLoadingAnimation from 'src/components/shared/placedLoadingAnimation.json';
// import Lottie from 'react-lottie-player';
import classNames from 'classnames';

const BorderLinearProgress = styled(LinearProgress)(({ }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#4B5563',
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: '#6161d9',
	},
}));

const NewCreatingPositionLoader = ({
	startingCustomText,
	midTimeCustomText,
	almostDoneCustomText,
	showAnimation = false,
	progressBar = true,
	customClassCss,
}: {
	startingCustomText?: string;
	midTimeCustomText?: string;
	almostDoneCustomText?: string;
	showAnimation?: boolean;
	progressBar?: boolean;
	customClassCss?: string;
}) => {
	const { themeMode } = useThemeContext();
	const [progress, setProgress] = useState(0);
	const [progressText, setProgressText] = useState(startingCustomText || 'Our AI is fetching company info...');

	useEffect(() => {
		const changeProgress = setInterval(() => {
			setProgress(prev => Math.min(95, prev + 10));
		}, 3000);

		return () => clearInterval(changeProgress);
	}, []);

	useEffect(() => {
		if (progress === 40) {
			setProgressText(midTimeCustomText || 'Our AI is generating job description...');
		} else if (progress === 80) {
			setProgressText(almostDoneCustomText || 'Our AI is calculating position level...');
		}
	}, [progress]);

	return (
		<div
			className={classNames(
				"relative w-full h-full flex flex-col justify-center items-center dark:bg-[#111E2C] [&>div[aria-label='progressbar']]:w-[90%] md:[&>div[aria-label='progressbar']]:w-[50%]",
				customClassCss,
			)}
		>
			{showAnimation ? (
				// <div className="relative left-0 right-0 mx-auto w-full h-full">
				// 	<Lottie play={true} loop={true} animationData={placedLoadingAnimation} />
				<div
					className="relative left-0 right-0 mx-auto w-full h-full flex justify-center items-center overflow-hidden"
					style={{
						width: '400px',
						height: '200px',
						position: 'relative'
					}}
				>
					<div
						style={{
							position: 'absolute',
							left: '0',
							top: '50%',
							transform: 'translateY(-50%)',
							width: '120px',
							height: '80px',
							animation: 'slideRight 3s linear infinite'
						}}
					>
						<img
							src="https://masai-website-images.s3.ap-south-1.amazonaws.com/levelup_dark_7c80e6bcf5.svg"
							alt="Levelup Logo"
							style={{
								width: '100%',
								height: '100%',
								objectFit: 'contain'
							}}
						/>
					</div>
					<style dangerouslySetInnerHTML={{
						__html: `
							@keyframes slideRight {
								0% { transform: translateY(-50%) translateX(-120px); }
								100% { transform: translateY(-50%) translateX(400px); }
							}
						`
					}} />
				</div>
			) : (
				<Img
					// src={
					// 	themeMode === 'dark'
					// 		? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
					// 		: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
					// }
					src="https://masai-website-images.s3.ap-south-1.amazonaws.com/levelup_dark_7c80e6bcf5.svg"
					alt="Levelup Logo"
				/>
			)}
			{progressBar ? (
				<div className={classNames('relative w-full text-center', showAnimation ? 'top-[-70px]' : '')}>
					<div className="flex gap-2 mb-2 w-fit mx-auto">
						<Img src="/assets/sparkles.svg" alt="sparkles_logo" className="object-contain" />
						<p className="whitespace-nowrap text-white">{progressText}</p>
					</div>
					<BorderLinearProgress
						value={progress}
						variant="determinate"
						sx={{ maxWidth: '340px', width: '100%', marginX: 'auto' }}
					/>
				</div>
			) : (
				''
			)}
		</div>
	);
};

export default NewCreatingPositionLoader;
